<template>
  <keep-alive>
    <div class="main">
      <!-- <el-row type="flex" align="center" justify="center"> -->
      <div class="shadow">
        <el-image :src="require('@/assets/LOGO.png')"></el-image>
        <div class="dropdown-header">
          <el-dropdown @command="handleCommand" >
            <span class="el-dropdown-link">
              <!-- <img :src="img" alt="" v-if="img"> -->
              <span v-if="name">{{ name }}</span><i class="el-icon-arrow-down el-icon--right" v-if="name"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="width:115px!important;">
              <el-dropdown-item :command="x" v-for="(x, y) in list" :key="y">{{
                x.serviceName
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- <el-col :span="8"> -->
      <div class="title1">数字捷智 统一身份认证</div>
      <div class="title2">智慧城市，亲手创造</div>

      <div class="container">
        <div>
          <div class="tab">
            <el-link
              v-if="$route.name !== 'forgetPwd'"
              :underline="false"
              href="/#/login"
              class="link"
              :class="{ active: $route.name == 'login' }"
              >登录</el-link
            >
            <el-link
              v-if="$route.name !== 'forgetPwd'"
              :underline="false"
              href="/#/register"
              class="link"
              :class="{ active: $route.name == 'register' }"
              >注册</el-link
            >
            <el-link :underline="false">
              <a 
                :href="registerHref"
                target="_blank"
                rel="nofollow"
                style="color: #000;text-decoration: none;font-size: 27px;padding: 5px 20px;cursor:pointer;"
                >商家注册</a>
            </el-link>
            <el-link
              v-if="$route.name === 'forgetPwd'"
              :underline="false"
              class="link"
              >忘记密码</el-link
            >
          </div>
          <slot />
        </div>
      </div>
      <!-- </el-col> -->
      <!-- </el-row> -->
      <p class="bottom">
        Copyright ©2019 备案号：
        <a
          href="http://www.beian.miit.gov.cn"
          target="_blank"
          rel="nofollow"
          style="color: #fff; text-decoration: none"
          >桂ICP备19012343号-1</a
        >
      </p>
    </div>
  </keep-alive>
</template>
<script>
import { setPartnerId, setPayUrlKey, setHomePage, setName ,setUrlTitle} from "@/utils/auth";
export default {
  name: "",
  data() {
    return {
      list: [],
      name: "惠百色",
      href: "",
      host: "",
      img:'',
      // href:"http://baise-portal-pc.baise.whdev.vpclub.cn/#/login",
      src:
        "https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg",
      registerHref: process.env.VUE_APP_REGISTER
    };
  },
  created() {
    this.href = window.location.href;
    
    if(window.location.hostname=="localhost"){
      this.href ="http://baise-portal-pc.baise.whdev.vpclub.cn/#/login"
    }else{
        if (window.location.protocol == "https:") {
      this.href = this.href.replace(/https/, "http");
    } 
    }
    console.log(this.registerHref);
    // https://admin-web.baise.gjsc.info/#/register
    // http://baise-admin-site.baise.whdev.vpclub.cn/#/register'
    this.host = window.location.hash;
    setTimeout(() => {
      this.appservice();
    }, 500);
  },
  mounted() {},
  methods: {
    appservice() {
      let config = {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        limit: 10,
        page: 1,
      };
      // let url;
      // // http://baise-portal-api.baise.whdev.vpclub.cn/
      // // http://portal-api.baise.vpclub.cn/
      // if(process.env.NODE_ENV=="development"){
      //   url="http://baise-portal-api.baise.whdev.vpclub.cn/"

      // }else{
      //   url='http://portal-api.baise.vpclub.cn/'
      // }
      this.$request.post("/api/web/appservice/list", config).then((res) => {
        console.log(res);
        if (res.code != 0) {
          return this.$message.error(res.msg);
        }
        this.list = res.data.list;
        this.list.forEach((x) => {
          if (x.pcUrl + this.host == this.href) {
            setPartnerId(x.partnerId);
            setPayUrlKey(x.payUrl);
            setHomePage(x.pcUrl);
            setName(x.serviceName);
            setUrlTitle(x.serviceName)
            this.name = x.serviceName;
          }
        });
      });
    },
    handleCommand(command) {
      window.location.href = command.pcUrl;
      //  this.img=command.url
      //   if(this.href!=serviceName.pcUrl){
      //     setHomePage(command.pcUrl);
      //     setName(command.serviceName);
      //     setPartnerId(command.partnerId);
      //     setPayUrlKey(command.payUrl);
      //       this.name = command.serviceName;
      //   }

      // setHomePage(command.pcUrl);
      // setName(command.serviceName);
      // setPartnerId(command.partnerId);
      // setPayUrlKey(command.payUrl);
      // this.name = command.serviceName;
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  height: 100vh;
  background: url("~@/assets/Login.png");
  background-size: cover;
  position: relative;
}

.bottom {
  width: 100%;
  font-family: PingFangSC-Regular;
  font-size: 21px;
  // color: #bac1ff;
  color: #fff;
  letter-spacing: 0;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 43px;
}
.shadow {
  width: 100%;
  height: 74px;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  // display: flex;
  .el-image {
    margin: 19px 0 0 7.8%;
  }
  .dropdown-header {
    width:140px;
    height:35px;
    line-height: 35px;
    color: #3963FF;
    font-size:22px;
    background:#fff;
    padding:0 15px;
    box-sizing: border-box;
    border-radius: 25px;
    // position: absolute;
    // top: 27px;
    // left: 18vw;
    display: inline-block;
    vertical-align: top;
    margin-top: 20px;
    .el-dropdown {
      color: #fff;
      font-size: 18px;
      cursor: pointer;

      
    }
    .el-dropdown-link {
      cursor: pointer;
       color: #3963FF;
    
       >img{
         width:20px;
         height:20px;
         line-height: 35px;
         vertical-align: top;
         padding-top:7px;
         object-fit: contain;

        
       }
       >span{
         padding-left:10px;
       }
    }
    .el-icon-arrow-down {
      font-size: 22px;
      vertical-align: middle;
      
    }
    .el-icon--right{
      margin-left:22px;
          padding-bottom: 3px;
    }
  }
}

.title1 {
  font-family: PingFangSC-Semibold;
  font-size: 71px;
  color: #ffffff;
  letter-spacing: 5.23px;
  line-height: 76px;
  position: absolute;
  top: 413px;
  left: 7.8%;
}

.title2 {
  font-family: PingFangSC-Light;
  font-size: 36px;
  font-weight: 300;
  color: #f9f9f9;
  letter-spacing: 2.73px;
  text-align: justify;
  line-height: 32px;
  position: absolute;
  top: 550px;
  left: 7.8%;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 100vh;
  width: 522px;
  height: 628px;
  position: relative;
  background: white;
  position: absolute;
  right: 12%;
  bottom: 14.3%;
  .tab {
    padding-bottom: 65.1px;
    .link {
      padding: 5px 20px;
      color: #4a4a4a;
      opacity: 0.4;
      font-size: 27px;
      &.active {
        color: #3963ff;
        font-size: 34px;
        font-weight: bold;
        opacity: 1;
        position: relative;
        &:after {
          content: "";
          display: block;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background-color: #3963ff;
          position: absolute;
          left: 45%;
          bottom: -10px;
        }
      }
    }
  }
}

</style>
<style lang="less">

</style>